// extracted by mini-css-extract-plugin
export default {"line":"Dashboard_line__mZcD5","card":"Dashboard_card__r5Ziw","alternate":"Dashboard_alternate__ryw95","jobcard":"Dashboard_jobcard__KyRMi"};